import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import data from "./data.json";

const CrateAccountEntryFull = () => {
    const navigate = useNavigate?.() ?? (() => { });

    const { header, form, buttons, table } = data;

    const initialForm = {
        date: "",
        partyCode: "",
        partyName: "",
        crateCode: "",
        crateName: "",
        crateCount: ""
    };

    const [formData, setFormData] = useState(initialForm);
    const [entries, setEntries] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);

    const [searchBy, setSearchBy] = useState({
        partyName: false,
        code: false,
        boxName: false,
        date: false
    });
    const [searchQuery, setSearchQuery] = useState({
        partyName: "",
        code: "",
        boxName: "",
        date: ""
    });

    const [boxList, setBoxList] = useState([]);
    const boxTotal = useMemo(
        () => boxList.reduce((s, b) => s + Number(b.qnt || 0), 0),
        [boxList]
    );

    const [drCrLeft, setDrCrLeft] = useState({ debit: "", credit: "", net: "" });
    const [drCrRight, setDrCrRight] = useState({ debit: "", credit: "", net: "" });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((p) => ({ ...p, [name]: value }));
    };

    const addBoxToList = () => {
        if (!formData.crateName || !formData.crateCount) return;
        setBoxList((p) => [...p, { box: formData.crateName, qnt: formData.crateCount }]);
        setFormData((p) => ({ ...p, crateCount: "" }));
    };

    const removeBox = (idx) => {
        setBoxList((p) => p.filter((_, i) => i !== idx));
    };

    const handleSave = () => {
        if (!formData.date || !formData.partyName || boxList.length === 0) return;
        const newEntry = {
            sr: entries.length + 1,
            date: formData.date,
            account: formData.partyName,
            boxName: boxList.map((b) => b.box).join(", "),
            quantity: boxTotal
        };
        setEntries((p) => [...p, newEntry]);
        setFormData(initialForm);
        setBoxList([]);
        setSelectedRow(null);
    };

    const handleCancel = () => {
        setFormData(initialForm);
        setBoxList([]);
        setSelectedRow(null);
    };

    const handleDelete = () => {
        if (selectedRow == null) return;
        setEntries((p) => p.filter((_, i) => i !== selectedRow).map((e, idx) => ({ ...e, sr: idx + 1 })));
        setSelectedRow(null);
    };

    const handlePrint = () => {
        window.print();
    };

    const toggleSearchBy = (key) => {
        setSearchBy((p) => ({ ...p, [key]: !p[key] }));
    };

    const handleShowSearch = () => {
    };

    const filteredEntries = useMemo(() => {
        return entries.filter((e) => {
            if (searchBy.partyName && searchQuery.partyName) {
                if (!e.account.toLowerCase().includes(searchQuery.partyName.toLowerCase())) return false;
            }
            if (searchBy.code && searchQuery.code) {
                if (!String(e.sr).includes(searchQuery.code)) return false;
            }
            if (searchBy.boxName && searchQuery.boxName) {
                if (!e.boxName.toLowerCase().includes(searchQuery.boxName.toLowerCase())) return false;
            }
            if (searchBy.date && searchQuery.date) {
                if (!e.date.includes(searchQuery.date)) return false;
            }
            return true;
        });
    }, [entries, searchBy, searchQuery]);

    const grandTotal = useMemo(
        () => filteredEntries.reduce((s, r) => s + Number(r.quantity || 0), 0),
        [filteredEntries]
    );

    const isSaveDisabled = !formData.date || !formData.partyName || boxList.length === 0;

    return (
        <div className="min-h-screen bg-[#e5ccb1] flex justify-center items-start p-4">
            <div className="w-[98%] max-w-[1400px] bg-[#e3c5a0] border-4 border-[#7b6144] shadow-lg rounded-sm overflow-hidden">
                <div className="flex items-center justify-between px-4 py-3 border-b-2 border-[#7b6144]">
                    <div className="text-left">
                        <h2 className="text-2xl font-bold text-[#3b2b1e]">{header.companyName}</h2>
                        <div className="text-sm text-[#3b2b1e]">
                            <span className="mr-3">{header.softwareName}</span>
                            <span>{header.contact}</span>
                        </div>
                        <div className="text-sm text-[#3b2b1e]">Phone: {header.phone}</div>
                    </div>

                    <div className="text-right flex gap-2 justify-between w-[50%]">
                        <div className="bg-[#f2dcae] px-4 py-2 border border-[#7b6144] rounded-sm w-[40%] flex items-center flex-col justify-center">
                            <div className="text-2xl font-extrabold">Entry Date</div>
                            <div className="text-sm">{new Date().toLocaleDateString()}</div>
                        </div>

                        <div className="self-end p-2 border border-[#7b6144] bg-[#f6e6d0] rounded-sm w-full h-full">
                            <div className="space-y-1">
                                <div className="flex flex-wrap gap-3">
                                    <label className="flex items-center gap-2 text-sm">
                                        <input type="checkbox" checked={searchBy.partyName} onChange={() => toggleSearchBy("partyName")} />
                                        <span>Party Name</span>
                                    </label>
                                    <label className="flex items-center gap-2 text-sm">
                                        <input type="checkbox" checked={searchBy.code} onChange={() => toggleSearchBy("code")} />
                                        <span>Code</span>
                                    </label>
                                    <label className="flex items-center gap-2 text-sm">
                                        <input type="checkbox" checked={searchBy.boxName} onChange={() => toggleSearchBy("boxName")} />
                                        <span>Box Name</span>
                                    </label>
                                    <label className="flex items-center gap-2 text-sm">
                                        <input type="checkbox" checked={searchBy.date} onChange={() => toggleSearchBy("date")} />
                                        <span>Date</span>
                                    </label>
                                </div>

                                <div className="mt-2 space-y-1">
                                    {searchBy.partyName && (
                                        <input
                                            className="w-full h-8 px-2 border rounded-sm"
                                            placeholder="Party name..."
                                            value={searchQuery.partyName}
                                            onChange={(e) => setSearchQuery((p) => ({ ...p, partyName: e.target.value }))}
                                        />
                                    )}
                                    {searchBy.code && (
                                        <input
                                            className="w-full h-8 px-2 border rounded-sm"
                                            placeholder="Code or SR..."
                                            value={searchQuery.code}
                                            onChange={(e) => setSearchQuery((p) => ({ ...p, code: e.target.value }))}
                                        />
                                    )}
                                    {searchBy.boxName && (
                                        <input
                                            className="w-full h-8 px-2 border rounded-sm"
                                            placeholder="Box name..."
                                            value={searchQuery.boxName}
                                            onChange={(e) => setSearchQuery((p) => ({ ...p, boxName: e.target.value }))}
                                        />
                                    )}
                                    {searchBy.date && (
                                        <input
                                            type="date"
                                            className="w-full h-8 px-2 border rounded-sm"
                                            value={searchQuery.date}
                                            onChange={(e) => setSearchQuery((p) => ({ ...p, date: e.target.value }))}
                                        />
                                    )}
                                </div>

                                <button
                                    onClick={handleShowSearch}
                                    className="mt-2 w-full py-1 bg-[#7b6144] text-white rounded-sm font-semibold"
                                >
                                    Show Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-[35%_24%_41%] gap-3 p-4">
                    <div className="bg-[#f4d9b1] p-4 border border-[#7b61444] rounded-sm relative">
                        <div className="space-y-2">
                            <div className="flex items-center gap-3">
                                <label className="w-36 text-sm font-semibold">Entry Date:</label>
                                <input
                                    type="date"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleChange}
                                    className="flex-1 h-9 px-2 border border-[#b9a089] rounded-sm bg-[#fff9e6]"
                                />
                            </div>

                            <div className="flex items-center gap-3">
                                <label className="w-36 text-sm font-semibold">Party Code No:</label>
                                <select
                                    name="partyCode"
                                    value={formData.partyCode}
                                    onChange={handleChange}
                                    className="flex-1 h-9 px-2 border border-[#b9a089] rounded-sm bg-[#e8f8ea]"
                                >
                                    <option value="">Select</option>
                                    {(form.partyCode.options || []).map((o) => (
                                        <option key={o} value={o}>
                                            {o}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex items-center gap-3">
                                <label className="w-36 text-sm font-semibold">Party Name:</label>
                                <select
                                    name="partyName"
                                    value={formData.partyName}
                                    onChange={handleChange}
                                    className="flex-1 h-9 px-2 border border-[#b9a089] rounded-sm bg-[#e8f8ea]"
                                >
                                    <option value="">Select</option>
                                    {(form.partyName.options || []).map((o) => (
                                        <option key={o} value={o}>
                                            {o}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex items-center gap-3">
                                <label className="w-36 text-sm font-semibold">Crate Code:</label>
                                <select
                                    name="crateCode"
                                    value={formData.crateCode}
                                    onChange={handleChange}
                                    className="flex-1 h-9 px-2 border border-[#b9a089] rounded-sm bg-pink-100"
                                >
                                    <option value="">Select</option>
                                    {(form.crateCode.options || []).map((o) => (
                                        <option key={o} value={o}>
                                            {o}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex items-center gap-3">
                                <label className="w-36 text-sm font-semibold">Crate Name:</label>
                                <select
                                    name="crateName"
                                    value={formData.crateName}
                                    onChange={handleChange}
                                    className="flex-1 h-9 px-2 border border-[#b9a089] rounded-sm bg-pink-100"
                                >
                                    <option value="">Select</option>
                                    {(form.crateName.options || []).map((o) => (
                                        <option key={o} value={o}>
                                            {o}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex items-center gap-3">
                                <label className="w-36 text-sm font-semibold">Total Crate Count:</label>
                                <input
                                    type="number"
                                    name="crateCount"
                                    value={formData.crateCount}
                                    onChange={handleChange}
                                    className="w-48 h-9 px-2 border border-[#b9a089] rounded-sm bg-[#fff9e6]"
                                />
                                <button
                                    onClick={addBoxToList}
                                    className="ml-2 px-3 py-1 h-9 bg-[#7b6144] text-white font-semibold rounded hover:bg-[#5b4632]"
                                >
                                    Add
                                </button>
                            </div>
                        </div>

                        <div className="mt-6 grid grid-cols-2 gap-3">
                            <div className="bg-[#f3e2c4] p-3 border border-[#b9a089] rounded-sm">
                                <div className="text-sm font-semibold mb-2">Debit :</div>
                                <input
                                    className="w-full h-8 px-2 border border-[#b9a089] rounded-sm mb-2"
                                    value={drCrLeft.debit}
                                    onChange={(e) => setDrCrLeft((p) => ({ ...p, debit: e.target.value }))}
                                />
                                <div className="text-sm font-semibold mb-2">Credit :</div>
                                <input
                                    className="w-full h-8 px-2 border border-[#b9a089] rounded-sm mb-2"
                                    value={drCrLeft.credit}
                                    onChange={(e) => setDrCrLeft((p) => ({ ...p, credit: e.target.value }))}
                                />
                                <div className="text-sm font-semibold mb-2">Net :</div>
                                <input
                                    className="w-full h-8 px-2 border border-[#b9a089] rounded-sm"
                                    value={drCrLeft.net}
                                    onChange={(e) => setDrCrLeft((p) => ({ ...p, net: e.target.value }))}
                                />
                            </div>

                            <div className="bg-[#f3e2c4] p-3 border border-[#b9a089] rounded-sm">
                                <div className="text-sm font-semibold mb-2">Debit :</div>
                                <input
                                    className="w-full h-8 px-2 border border-[#b9a089] rounded-sm mb-2"
                                    value={drCrRight.debit}
                                    onChange={(e) => setDrCrRight((p) => ({ ...p, debit: e.target.value }))}
                                />
                                <div className="text-sm font-semibold mb-2">Credit :</div>
                                <input
                                    className="w-full h-8 px-2 border border-[#b9a089] rounded-sm mb-2"
                                    value={drCrRight.credit}
                                    onChange={(e) => setDrCrRight((p) => ({ ...p, credit: e.target.value }))}
                                />
                                <div className="text-sm font-semibold mb-2">Net :</div>
                                <input
                                    className="w-full h-8 px-2 border border-[#b9a089] rounded-sm"
                                    value={drCrRight.net}
                                    onChange={(e) => setDrCrRight((p) => ({ ...p, net: e.target.value }))}
                                />
                            </div>
                        </div>

                    </div>

                    <div className="flex flex-col justify-between">
                        <div className="bg-white p-2 border border-[#7b6144] rounded-sm flex flex-col h-[50%]">
                            <div className="border-b border-[#7b6144] pb-1 flex items-center justify-between">
                                <div className="text-sm font-semibold">Box</div>
                                <div className="text-sm font-semibold">Qnt</div>
                            </div>

                            <div className="flex-1 overflow-auto my-2">
                                {boxList.length === 0 ? (
                                    <div className="text-sm text-gray-500 p-2">No boxes added.</div>
                                ) : (
                                    boxList.map((b, idx) => (
                                        <div key={idx} className="flex items-center justify-between px-2 py-1 hover:bg-[#f3e2c4]">
                                            <div className="truncate">{b.box}</div>
                                            <div className="flex items-center gap-2">
                                                <div className="w-12 text-right">{b.qnt}</div>
                                                <button onClick={() => removeBox(idx)} className="text-xs px-2 py-1 border rounded-sm">x</button>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                            <div className="border-t border-[#7b6144] pt-1 flex items-center justify-between">
                                <div className="text-sm font-semibold">Total</div>
                                <div className="w-12 text-right font-semibold">{boxTotal}</div>
                            </div>
                        </div>
                        <div className="mt-4 flex flex-col gap-3 items-stretch ">
                            <button
                                onClick={handleSave}
                                disabled={isSaveDisabled}
                                className={`py-2 font-semibold rounded ${isSaveDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-[#7b6144] text-white hover:bg-[#5b4632]"}`}
                            >
                                {buttons.save}
                            </button>

                            <div className="flex gap-3">
                                <button onClick={handleCancel} className="flex-1 py-2 bg-[#7b6144] text-white font-semibold rounded hover:bg-[#5b4632]">
                                    {buttons.cancel}
                                </button>
                                <button onClick={handlePrint} className="flex-1 py-2 bg-[#7b6144] text-white font-semibold rounded hover:bg-[#5b4632]">
                                    {buttons.print}
                                </button>
                            </div>

                            <button
                                onClick={handleDelete}
                                className={`py-2 font-semibold rounded ${selectedRow == null ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#8b6d55] text-white hover:bg-[#7b5a40]"}`}
                                disabled={selectedRow == null}
                            >
                                {buttons.delete}
                            </button>

                            <button
                                onClick={() => navigate("/dashboard")}
                                className="py-2 font-semibold rounded bg-[#7b6144] text-white hover:bg-[#5b4632]"
                            >
                                {buttons.exit}
                            </button>
                        </div>
                    </div>

                    <div className="bg-[#fdf5eb] p-2 border border-[#7b6144] rounded-sm flex flex-col h-[560px]">

                        <div className="flex-1 overflow-auto border border-[#d6c3a9] rounded-sm">
                            <table className="w-full border-collapse text-sm">
                                <thead className="bg-[#e3c5a0] sticky top-0">
                                    <tr>
                                        {table.headers.map((h, i) => (
                                            <th key={i} className="border border-[#7b6144] px-3 py-2 text-left">{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredEntries.length === 0 ? (
                                        <tr>
                                            <td colSpan={table.headers.length} className="p-6 text-center text-gray-500">No entries yet</td>
                                        </tr>
                                    ) : (
                                        filteredEntries.map((r, idx) => (
                                            <tr
                                                key={idx}
                                                onClick={() => setSelectedRow(idx)}
                                                className={`${selectedRow === idx ? "bg-[#dcd2c0]" : "hover:bg-[#f7efe0]"} cursor-pointer`}
                                            >
                                                <td className="border px-2 py-2">{r.sr}</td>
                                                <td className="border px-2 py-2">{r.date}</td>
                                                <td className="border px-2 py-2">{r.account}</td>
                                                <td className="border px-2 py-2">{r.boxName}</td>
                                                <td className="border px-2 py-2 text-right">{r.quantity}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-2 border-t border-[#7b6144] pt-2 flex items-center justify-between">
                            <div className="text-sm font-semibold">Total</div>
                            <div className="w-20 h-8 bg-white border border-[#7b6144] flex items-center justify-center text-sm font-semibold">{grandTotal}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CrateAccountEntryFull;